var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "px-6 py-4 analytics-sticky bg-slate-300" }, [
      _c(
        "div",
        { staticClass: "flex items-center justify-between" },
        [
          _c("BlTextTitle3", { attrs: { text: "Cancellation Overview" } }),
          _vm._v(" "),
          _c("BlInputButton", {
            attrs: {
              type: "outlined",
              label: "Export to csv",
              loading: _vm.exportLoading
            },
            on: { clicked: _vm.onExportCSV }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center gap-2 py-3" },
        [
          _vm.enableBranch
            ? _c(
                "div",
                { staticClass: "w-40" },
                [
                  _c("BlSelectBox", {
                    attrs: { type: "branch", options: _vm.branchOptions },
                    on: {
                      change: function($event) {
                        return _vm.onChangeBranch($event)
                      }
                    },
                    model: {
                      value: _vm.branchInput,
                      callback: function($$v) {
                        _vm.branchInput = $$v
                      },
                      expression: "branchInput"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("BlInputSearch", {
            staticClass: "w-80",
            attrs: { input: _vm.searchInput },
            on: { changed: _vm.onInputSearch }
          }),
          _vm._v(" "),
          _c("BlInputFilter", {
            staticClass: "w-40",
            attrs: { input: _vm.filterInput },
            on: { changed: _vm.onChangeFilter }
          }),
          _vm._v(" "),
          _c("BlInputSelect", {
            attrs: { input: _vm.groupByInput },
            on: { changed: _vm.onChangeGroupBy }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col gap-2 pt-4" }, [
        _c(
          "div",
          [
            _c("BlTextBody2", { attrs: { text: "Showing results for " } }),
            _vm._v(" "),
            _c("BlTextSubtitle3", { attrs: { text: _vm.activeDateRange } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex gap-5 pb-4 overflow-x-auto overflow-y-hidden scrollbar-lg"
          },
          [
            _c(
              "div",
              {
                staticClass: "flex-shrink-0 rounded-3xl bg-pure-white",
                style: { height: "25rem", width: "10rem" }
              },
              [
                _vm.fetchGraphLoading
                  ? _c(
                      "div",
                      { staticClass: "grid h-full place-content-center" },
                      [_c("div", { staticClass: "blum-loader" })]
                    )
                  : !_vm.graphData
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "grid flex-col h-full text-center place-content-center"
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "px-4 font-semibold",
                          attrs: { text: _vm.emptyState.title }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col items-center justify-center h-full py-4"
                      },
                      _vm._l(_vm.overviewData, function(item) {
                        return _c(
                          "div",
                          { key: item.label, staticClass: "w-full" },
                          [
                            _c(
                              "BlTooltip",
                              {
                                staticClass: "flex flex-col w-full px-4",
                                attrs: {
                                  tooltip:
                                    "<div class='flex flex-col gap-1 text-left w-60'>\n                    <b>" +
                                    item.tooltip.title +
                                    "</b>\n                    <div>" +
                                    item.tooltip.desc +
                                    "</div>\n                  </div>",
                                  drop: "right"
                                }
                              },
                              [
                                _c("BlTextTitle3", {
                                  staticClass: "self-center text-slate-900",
                                  attrs: { text: item.value }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center truncate" },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "truncate",
                                      attrs: { text: item.label }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            item.divider
                              ? _c("div", { staticClass: "px-4 py-3" }, [
                                  _c("div", {
                                    staticClass:
                                      "h-0.5 flex-grow flex-shrink-0 bg-slate-300"
                                  })
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
              ]
            ),
            _vm._v(" "),
            _vm.groupByTime
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex-grow flex-shrink-0 rounded-3xl bg-pure-white",
                    style: { height: "25rem", width: "auto" }
                  },
                  [
                    _vm.fetchGraphLoading
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : _vm.barChartDataAppointment.empty
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "grid flex-col h-full text-center place-content-center"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "px-4 font-semibold",
                              attrs: { text: _vm.emptyState.title }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.emptyState.desc, function(text, idx) {
                              return _c("BlTextBody2", {
                                key: idx,
                                staticClass: "px-4",
                                attrs: { text: text }
                              })
                            })
                          ],
                          2
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-4 px-6 py-6" },
                          [
                            _c("BlTextSubtitle2", {
                              staticClass: "text-slate-700",
                              attrs: { text: "Cancellation by Hours" }
                            }),
                            _vm._v(" "),
                            _c("BarChart", {
                              attrs: {
                                labels: _vm.barChartDataAppointment.labels,
                                datasets: _vm.barChartDataAppointment.datasets,
                                stacked: "",
                                width:
                                  "calc((100vw - 15rem - 3.5rem) - 10rem - 1.25rem - 3rem - 1.25rem - 13rem - 1.25rem - 13rem)"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-5" },
                              _vm._l(
                                _vm.barChartDataAppointment.legends,
                                function(legend) {
                                  return _c(
                                    "div",
                                    {
                                      key: legend.label,
                                      staticClass: "flex items-center gap-1",
                                      attrs: { title: legend.label }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                        style: { backgroundColor: legend.color }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: { text: legend.label }
                                      })
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          ],
                          1
                        )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.groupByInput.model.value === "client" ||
            _vm.groupByInput.model.value === "user"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex-grow flex-shrink-0 rounded-3xl bg-pure-white",
                    style: { height: "25rem", width: "auto" }
                  },
                  [
                    _vm.fetchGraphLoading
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : _vm.barChartDataRole.empty
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "grid flex-col h-full text-center place-content-center"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "px-4 font-semibold",
                              attrs: { text: _vm.emptyState.title }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.emptyState.desc, function(text, idx) {
                              return _c("BlTextBody2", {
                                key: idx,
                                staticClass: "px-4",
                                attrs: { text: text }
                              })
                            })
                          ],
                          2
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-4 px-6 py-6" },
                          [
                            _c("BlTextSubtitle2", {
                              staticClass: "text-slate-700",
                              attrs: { text: "Cancellation by Hours" }
                            }),
                            _vm._v(" "),
                            _c("BarChart", {
                              attrs: {
                                labels: _vm.barChartDataRole.labels,
                                datasets: _vm.barChartDataRole.datasets,
                                horizontal: "",
                                stacked: "",
                                width:
                                  "calc((100vw - 15rem - 3.5rem) - 10rem - 1.25rem - 3rem)"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h-5.5 flex items-end justify-between gap-5"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-5" },
                                  _vm._l(_vm.barChartDataRole.legends, function(
                                    legend
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: legend.label,
                                        staticClass: "flex items-center gap-1",
                                        attrs: { title: legend.label }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                          style: {
                                            backgroundColor: legend.color
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: { text: legend.label }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.barChartDataTotalCount > _vm.barChartPerPage
                                  ? _c("BlInputPagination", {
                                      attrs: {
                                        count: Math.ceil(
                                          _vm.barChartDataTotalCount /
                                            _vm.barChartPerPage
                                        ),
                                        page: _vm.barChartPage
                                      },
                                      on: { changed: _vm.changeBarChartPage }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.groupByTime
              ? _c(
                  "div",
                  {
                    staticClass: "flex-shrink-0 rounded-3xl bg-pure-white",
                    style: { height: "25rem", width: "13rem" }
                  },
                  [
                    _vm.fetchGraphLoading
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : !_vm.graphData
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "grid flex-col h-full text-center place-content-center"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "px-4 font-semibold",
                              attrs: { text: _vm.emptyState.title }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-6 px-6 py-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "h-12" },
                              [
                                _c("BlTextSubtitle2", {
                                  staticClass: "text-slate-700",
                                  attrs: { text: "Cancellation requested by" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("PieChart", {
                              attrs: {
                                labels: _vm.pieChartDataRequester.labels,
                                colors: _vm.pieChartDataRequester.colors,
                                data: _vm.pieChartDataRequester.data
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-3 h-15" },
                              _vm._l(_vm.pieChartLegendsRequester, function(
                                legend
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: legend.label,
                                    staticClass:
                                      "flex items-center justify-between gap-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-1 truncate",
                                        attrs: { title: legend.label }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                          style: {
                                            backgroundColor: legend.color
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: { text: legend.label }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("BlTextSubtitle3", {
                                          staticClass: "text-slate-800",
                                          attrs: { text: legend.value }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.pieChartPageCountRequester > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center"
                                  },
                                  _vm._l(
                                    _vm.pieChartPageCountRequester,
                                    function(n) {
                                      return _c(
                                        "div",
                                        {
                                          key: n,
                                          staticClass: "p-1 cursor-pointer",
                                          on: {
                                            click: function($event) {
                                              _vm.pieChartPageRequester = n
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "h-2.5 w-2.5 flex-shrink-0 rounded-full hover:bg-slate-700 transition-all duration-300",
                                            class: [
                                              _vm.pieChartPageRequester === n
                                                ? "bg-slate-700"
                                                : "bg-slate-500"
                                            ]
                                          })
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ],
                          1
                        )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.groupByTime
              ? _c(
                  "div",
                  {
                    staticClass: "flex-shrink-0 rounded-3xl bg-pure-white",
                    style: { height: "25rem", width: "13rem" }
                  },
                  [
                    _vm.fetchGraphLoading
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : !_vm.graphData
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "grid flex-col h-full text-center place-content-center"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "px-4 font-semibold",
                              attrs: { text: _vm.emptyState.title }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-6 px-6 py-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "h-12" },
                              [
                                _c("BlTextSubtitle2", {
                                  staticClass: "text-slate-700",
                                  attrs: { text: "Cancellation reasons" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("PieChart", {
                              attrs: {
                                labels: _vm.pieChartDataReason.labels,
                                colors: _vm.pieChartDataReason.colors,
                                data: _vm.pieChartDataReason.data
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-3 h-15" },
                              _vm._l(_vm.pieChartLegendsReason, function(
                                legend
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: legend.label,
                                    staticClass:
                                      "flex items-center justify-between gap-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-1 truncate",
                                        attrs: { title: legend.label }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                          style: {
                                            backgroundColor: legend.color
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: { text: legend.label }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("BlTextSubtitle3", {
                                          staticClass: "text-slate-800",
                                          attrs: { text: legend.value }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.pieChartPageCountReason > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center"
                                  },
                                  _vm._l(_vm.pieChartPageCountReason, function(
                                    n
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: n,
                                        staticClass: "p-1 cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.pieChartPageReason = n
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-2.5 w-2.5 flex-shrink-0 rounded-full hover:bg-slate-700 transition-all duration-300",
                                          class: [
                                            _vm.pieChartPageReason === n
                                              ? "bg-slate-700"
                                              : "bg-slate-500"
                                          ]
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ],
                          1
                        )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          {
            staticClass:
              "z-10 flex items-center justify-between px-6 py-4 analytics-sticky top-18 bg-slate-100"
          },
          [
            _c(
              "div",
              [
                _c("BlTextBody2", {
                  attrs: { text: "Showing all " + _vm.tableCount + " " }
                }),
                _vm._v(" "),
                _vm.groupByTime
                  ? _c("BlTextBody2", { attrs: { text: "session(s)" } })
                  : _vm.groupByInput.model.value === "client"
                  ? _c("BlTextBody2", { attrs: { text: "client(s)" } })
                  : _vm.groupByInput.model.value === "user"
                  ? _c("BlTextBody2", { attrs: { text: "member(s)" } })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("BlSort", {
              attrs: {
                options: _vm.sortOptions,
                defaultValue: _vm.defaultSort,
                dropDirection: "left"
              },
              on: { change: _vm.onChangeSort },
              model: {
                value: _vm.sortInput,
                callback: function($$v) {
                  _vm.sortInput = $$v
                },
                expression: "sortInput"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.fetchTableLoading
          ? _c(
              "div",
              {
                staticClass: "grid h-64 analytics-sticky place-content-center"
              },
              [_c("div", { staticClass: "blum-loader" })]
            )
          : _vm.groupByTime
          ? _c("TableCancellationOverview", {
              attrs: { tableData: _vm.tableData }
            })
          : _vm.groupByInput.model.value === "client"
          ? _c("TableCancellationClient", {
              attrs: { tableData: _vm.tableData }
            })
          : _vm.groupByInput.model.value === "user"
          ? _c("TableCancellationTherapist", {
              attrs: { tableData: _vm.tableData }
            })
          : _c("div", { staticClass: "px-6 pt-4" }, [
              _c(
                "div",
                { staticClass: "flex flex-col gap-2 text-xxs" },
                _vm._l(_vm.tableData, function(n) {
                  return _c(
                    "div",
                    { key: n.id, staticClass: "whitespace-no-wrap" },
                    [_vm._v("\n          " + _vm._s(n) + "\n        ")]
                  )
                }),
                0
              )
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "px-6 pt-4 analytics-sticky pb-36" },
          [
            _vm.tableCount > 25
              ? _c("BlInputPagination", {
                  attrs: {
                    page: _vm.page,
                    perPage: _vm.perPage,
                    total: _vm.tableCount
                  },
                  on: {
                    changed: _vm.changePage,
                    "changed-per-page": _vm.changePerPage
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-995b2b96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-995b2b96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/CancellationOverview.vue
// module id = null
// module chunks = 